export default class DebugPane {
    pane;

    // Import dinàmic: tweakpane (271KB) només s'ha de baixar quan isDebug és true,
    // mai al bundle de producció.
    static async init() {
        const { Pane } = await import('tweakpane');
        this.pane = new Pane({ title: 'Settings', expanded: false });
    }

    static dispose() {
        if (this.pane) {
            this.pane.dispose();
            this.pane = null;
        }
    }
}
